import React from 'react';
import { FlameIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-16 px-4 relative overflow-hidden" data-id="element-118">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[500px] bg-gold-900/10 blur-[150px] rounded-full pointer-events-none" data-id="element-119"></div>

      <div className="max-w-4xl mx-auto text-center space-y-8 relative z-10" data-id="element-120">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 text-sm font-bold tracking-widest text-gold-400 border border-gold-500/30 bg-gold-950/40 uppercase rounded-full backdrop-blur-sm shadow-[0_0_15px_rgba(201,168,76,0.1)]" data-id="element-121">
          PROPRIETARY FRAMEWORK
        </div>

        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold-950 border border-gold-700 shadow-[0_0_30px_rgba(201,168,76,0.2)]" data-id="element-122">
          <FlameIcon className="w-10 h-10 text-gold-400" data-id="element-123" />
        </div>

        <h2 className="text-5xl md:text-6xl font-black text-transparent bg-clip-text bg-gold-gradient" data-id="element-124">
          The Legacy of the Unbreakable Voice
        </h2>

        <div className="prose prose-invert prose-xl mx-auto text-zinc-300 leading-relaxed" data-id="element-125">
          <p data-id="element-126">
            This exclusive eBook uses the revolutionary narrative of{' '}
            <strong className="text-gold-100" data-id="element-127">"Predictive History"</strong> to
            expose you to reality without filters. It's not a boring political
            analysis; it's a direct transfer of courage and strategic dominance.
          </p>
          <p data-id="element-128">
            Through the analysis of Kirk's rise, fall, and ideological
            resurrection, we activate in the reader the{' '}
            <strong className="text-gold-100" data-id="element-129">
              Muscle of Civil Resistance
            </strong>
            .
          </p>
          <blockquote className="border-y border-gold-800/50 py-6 my-8 text-3xl font-serif text-gold-50 italic bg-gradient-to-r from-transparent via-gold-950/30 to-transparent" data-id="element-130">
            "You will learn that an idea doesn't die when the leader disappears,
            but when the followers decide to inherit their voice."
          </blockquote>
        </div>
      </div>
    </section>;
}